import React, { FunctionComponent, useMemo, useState } from "react";
import styles from "./styles.module.scss";
import { Card, Grid, GridSize, Skeleton } from "@mui/material";
import { strings } from "../../../../localization/LocalizedStrings";
import { AttributeDesktop } from "../../AttributeDesktop";
import { attributeIconMap } from "../../../../models/AttributeUtilities";
import { AttributeType } from "../../AttributeList";
import { ICountry, useGetCountries } from "../../../../hooks/countries";
import { OriginCountryCard } from "../../originCountries/OriginCountryCard";

export const CountriesDesktop: FunctionComponent<ICountriesDesktopProps> = ({
  handleClose,
  columnWidth,
  preselectedIsoCode,
  onCountrySelected,
  onClearValue
}) => {
  const [loading, setLoading] = useState(false);
  const countries = useGetCountries(setLoading, []);
  const [searchText, setSearchText] = useState("");
  const filteredCountries = useMemo(() => {
    if (searchText == "") {
      return countries;
    }
    return countries?.filter(country => {
      return (
        country.isoCode.toLowerCase().includes(searchText.toLowerCase()) ||
        country.isoCode2.toLowerCase().includes(searchText.toLowerCase()) ||
        country.name.toLowerCase().includes(searchText.toLowerCase()) ||
        country.emoji.toLowerCase().includes(searchText.toLowerCase())
      );
    });
  }, [countries, searchText]);
  return (
    <AttributeDesktop
      handleClose={handleClose}
      isPublic={false}
      items={filteredCountries}
      emptyIconType={attributeIconMap[AttributeType.ORIGIN_COUNTRIES]}
      emptyString={strings.empty_countries}
      title={strings.attribute_countries_title}
      loading={loading}
      setLoading={setLoading}
      onSearchRequested={searchText => setSearchText(searchText)}
      onClearValue={onClearValue}
    >
      {filteredCountries?.map(country => (
        <Grid item key={country.isoCode} xs={columnWidth}>
          <Card sx={{ borderRadius: "20px" }} elevation={5}>
            <OriginCountryCard
              name={country.name}
              isoCode={country.isoCode}
              emoji={country.emoji}
              onClick={() => {
                if (onCountrySelected) {
                  onCountrySelected(country);
                }
              }}
              onContextMenu={() => {}}
              selected={preselectedIsoCode == country.isoCode}
            />
          </Card>
        </Grid>
      ))}
      {loading &&
        Array.from({ length: 50 }, (_value, index) => (
          <Grid key={index} item xs={columnWidth}>
            <Skeleton variant={"rectangular"} sx={{ height: 100 }} className={styles.skeleton} />
          </Grid>
        ))}
    </AttributeDesktop>
  );
};

export interface ICountriesDesktopProps {
  handleClose?: () => void;
  columnWidth: GridSize;
  preselectedIsoCode?: string;
  onCountrySelected?: (country: ICountry) => void;
  onClearValue?: () => void;
}
